<template>
	<section>
		<loader :dialog="loading"></loader>

		<div class="reward-add-row">
			<v-dialog v-model="dialog" width="460" scrollable>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						depressed
						rounded
						small
						class="reward-add-btn"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon left small>mdi-plus</v-icon>
						Nouvelle récompense
					</v-btn>
				</template>

				<v-card rounded="xl" class="pa-2">
					<div class="rw-header">
						<div class="rw-icon-box">
							<v-icon size="18" color="white">mdi-trophy</v-icon>
						</div>
						<div>
							<p class="rw-title">Nouvelle récompense</p>
							<p class="rw-subtitle">Définir les critères</p>
						</div>
						<v-spacer></v-spacer>
						<v-btn icon small @click="dialog = false">
							<v-icon color="#6b7280">mdi-close</v-icon>
						</v-btn>
					</div>

					<v-divider></v-divider>

					<v-card-text class="pt-5">
						<v-text-field
							v-model="reward.label"
							label="Intitulé de la récompense"
							outlined
							dense
							rounded
							prepend-inner-icon="mdi-tag-outline"
							hide-details
							class="mb-4"
						></v-text-field>
						<label class="field-label">Nombre de points</label>
						<vue-number-input
							v-model="reward.point"
							center
							size="small"
							controls
							class="mt-2"
						></vue-number-input>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions class="pa-4">
						<v-btn text color="error" rounded @click="dialog = false">
							Annuler
						</v-btn>
						<v-spacer></v-spacer>
						<v-btn
							depressed
							rounded
							class="rw-save-btn"
							@click="addReward"
						>
							Enregistrer
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>

		<div
			v-for="(reward, index) in rewards"
			:key="index"
			class="reward-item"
			@click="attributeReward(reward.point)"
		>
			<div class="reward-trophy-box">
				<v-icon size="18" color="white">mdi-trophy</v-icon>
			</div>
			<div class="reward-info">
				<p class="reward-name">{{ reward.label }}</p>
				<p class="reward-points">
					<v-icon size="12" color="#f59e0b">mdi-star</v-icon>
					{{ reward.point }} points
				</p>
			</div>
			<v-icon size="16" color="#d1d5db">mdi-chevron-right</v-icon>
		</div>
	</section>
</template>

<script>
import Loader from "@/components/Loader.vue";
import service from "@/services";
export default {
	props: ["rewards", "customerId"],
	components: { Loader },
	data() {
		return {
			dialog: false,
			loading: false,
			reward: {
				point: 0,
				label: "",
			},
		};
	},
	methods: {
		attributeReward(points) {
			this.loading = true;
			service
				.attributeReward(this.customerId, points)
				.then(() => {
					this.$emit("close-reward-dialog");
					this.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.loading = false;
					this.dialog = false;
				});
		},
		addReward() {
			this.loading = true;
			service
				.addReward(this.reward)
				.then(() => {
					this.dialog = false;
					this.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.loading = false;
				});
		},
	},
};
</script>

<style scoped>
.reward-add-row {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 16px;
}
.reward-add-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.78rem;
}
.rw-header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 18px 20px 14px;
}
.rw-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: linear-gradient(135deg, #f59e0b, #d97706);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.rw-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.rw-subtitle {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.field-label {
	font-size: 0.75rem;
	font-weight: 600;
	color: #6b7280;
	font-family: Montserrat, sans-serif;
}
.rw-save-btn {
	background: #1565c0 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
}
.reward-item {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 12px;
	border-radius: 12px;
	cursor: pointer;
	transition: background 0.15s;
	font-family: Montserrat, sans-serif;
}
.reward-item:hover {
	background: #f9fafb;
}
.reward-trophy-box {
	width: 36px;
	height: 36px;
	border-radius: 10px;
	background: linear-gradient(135deg, #f59e0b, #d97706);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.reward-info {
	flex: 1;
}
.reward-name {
	font-size: 0.85rem;
	font-weight: 600;
	color: #111827;
	margin: 0 0 2px;
}
.reward-points {
	font-size: 0.72rem;
	color: #6b7280;
	margin: 0;
	display: flex;
	align-items: center;
	gap: 4px;
}
</style>

